import { render, staticRenderFns } from "./WaterFluctuation.vue?vue&type=template&id=1b298a22&scoped=true"
import script from "./WaterFluctuation.vue?vue&type=script&lang=js"
export * from "./WaterFluctuation.vue?vue&type=script&lang=js"
import style0 from "./WaterFluctuation.vue?vue&type=style&index=0&id=1b298a22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b298a22",
  null
  
)

export default component.exports